export default {
  API_RESOURCE: 'user_invites'
}
